import { jsx } from "react/jsx-runtime";
import { InputAdornment, TextField as MuiTextField } from "@mui/material";
import { Error as ErrorIcon } from "../../icons/index.js";
function TextField(props) {
  const {
    errorIcon = /* @__PURE__ */ jsx(ErrorIcon, { color: "error" }),
    avoidDisplayingErrorIcon,
    testId = "TidalTextField-root",
    ...rest
  } = props;
  const { error } = props;
  const renderMuiTextfield = !error || avoidDisplayingErrorIcon;
  if (renderMuiTextfield) {
    return /* @__PURE__ */ jsx(MuiTextField, { "data-tidal": "TextField", ...rest, "data-testid": testId });
  }
  return /* @__PURE__ */ jsx(
    MuiTextField,
    {
      "data-tidal": "TextField",
      ...rest,
      "data-testid": testId,
      InputProps: {
        ...rest.InputProps,
        endAdornment: /* @__PURE__ */ jsx(InputAdornment, { position: "end", children: errorIcon })
      }
    }
  );
}
export {
  TextField
};
//# sourceMappingURL=TextField.js.map
